import { useContext } from 'react';

import { TaskDetailContext } from './task-detail-context';

export const useOpenCreateTask = () => {
  const { openCreateTask } = useContext(TaskDetailContext);

  return openCreateTask;
};
